import React, { Component } from "react";

import SwitchHours from "./components/SwitchHours";
import { Localized } from "fluent-react/compat";
import CallApi from "../../../utils/CallApi";
import ClosingDate from "../ClosingDate";
import { withSnackbar } from "notistack";
import Slots from "./components/Slots";
import moment from "moment";

class HoursV3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayScreenCloseDates: props.displayScreenCloseDates,
      closingDate: props.closingDate,
      restaurantId: props.restaurantId,
      selectedDays: props.openingDate,
      addTimeRangeInProgress: false,
      indexTimeRangeUpdated: -1,
      isUpdateInProcess: false,
      formateOpeningHours: [],
      addingNewHours: false,
      maxSlotTimesDays: 0,
      displaySlotTimes: 0,
      slotUpdated: null,
      emptySlot: [
        {
          monday: ""
        },
        {
          tuesday: ""
        },
        {
          wednesday: ""
        },
        {
          thursday: ""
        },
        {
          friday: ""
        },
        {
          saturday: ""
        },
        {
          sunday: ""
        }
      ],
      success: false,
      dayUpdated: ""
    };
    this.formateOpeningHours = this.formateOpeningHours.bind(this);
    this.updateTimeRangeDay = this.updateTimeRangeDay.bind(this);
    this.displayCloseDates = this.displayCloseDates.bind(this);
    this.timeRangeUpdated = this.timeRangeUpdated.bind(this);
    this.updateDaysOfWeek = this.updateDaysOfWeek.bind(this);
    this.createArraySlot = this.createArraySlot.bind(this);
    this.addClosingDates = this.addClosingDates.bind(this);
    this.checkDateRange = this.checkDateRange.bind(this);
    this.addTimeRange = this.addTimeRange.bind(this);
    this.displayError = this.displayError.bind(this);
    this.goBottomPage = this.goBottomPage.bind(this);
    this.scrollToLeft = this.scrollToLeft.bind(this);
    this.goToSettings = this.goToSettings.bind(this);
    this.addSlotTime = this.addSlotTime.bind(this);
    this.submitData = this.submitData.bind(this);
    this.updateDay = this.updateDay.bind(this);
  }

  componentDidMount() {
    const { selectedDays } = this.state;
    let maxSlotTimesDays = this.findMaxSlot(selectedDays);
    let formateOpeningHours = [];
    if (maxSlotTimesDays) {
      formateOpeningHours = this.formateOpeningHours(
        selectedDays,
        maxSlotTimesDays
      );
    } else {
      const newSlot = { slot1: this.state.emptySlot };
      maxSlotTimesDays = 1;
      formateOpeningHours.push(newSlot);
    }
    this.setState(
      {
        displaySlotTimes: maxSlotTimesDays,
        maxSlotTimesDays,
        formateOpeningHours
      },
      () => this.goBottomPage()
    );
  }

  formateOpeningHours(selectedDays, maxSlot) {
    const days = Object.keys(selectedDays);
    const arr = this.createArraySlot(maxSlot);
    return days.reduce((acc, day) => {
      const hours = selectedDays[day];
      if (hours.length) {
        acc.map((slot, index) => {
          const keyName = Object.keys(slot);
          if (hours[index]) {
            slot[keyName] = [...slot[keyName], { [day]: hours[index] }];
          } else {
            slot[keyName] = [...slot[keyName], { [day]: "" }];
          }
          return slot;
        });
      } else {
        acc.map(slot => {
          const keyName = Object.keys(slot);
          if (slot[keyName].length) {
            slot[keyName] = [...slot[keyName], { [day]: "" }];
          } else {
            slot[keyName] = [{ [day]: "" }];
          }
          return slot;
        });
      }
      return acc;
    }, arr);
  }

  async updateTimeRangeDay(e, day, newHours, indexTimeRange, action) {
    let copyDays = Object.assign({}, this.state.selectedDays);
    let sendData = true;
    const {
      displayScreenCloseDates,
      addTimeRangeInProgress,
      displaySlotTimes
    } = this.state;
    if (
      (action === "remove" &&
        copyDays[day].length === 1 &&
        !addTimeRangeInProgress) ||
      action === "removeAll"
    ) {
      copyDays[day] = [];
    } else if (
      action === "remove" &&
      !copyDays[day].length &&
      addTimeRangeInProgress
    ) {
      copyDays[day] = [];
      sendData = false;
    } else {
      copyDays[day] = this.updateDay(
        copyDays[day],
        action,
        newHours,
        indexTimeRange
      );
    }
    const newDays = this.updateDaysOfWeek(day, copyDays);
    const formateOpeningHours = this.formateOpeningHours(
      newDays,
      displaySlotTimes
    );
    const openingDate = {
      update: "openingDate",
      openingDate: newDays
    };
    const dataSent = sendData ? await this.submitData(openingDate) : true;
    if (dataSent) {
      this.setState(
        {
          addTimeRangeInProgress: false,
          indexTimeRangeUpdated: -1,
          isUpdateInProcess: false,
          addingNewHours: false,
          formateOpeningHours
        },
        () => this.props.onUpdateOpeningDate(newDays, displayScreenCloseDates),
        this.props.enqueueSnackbar(<Localized id="tr-admin-change" />, {
          variant: "success"
        })
      );
    } else {
      this.displayError("noDatas");
    }
  }

  displayCloseDates() {
    this.setState({
      displayScreenCloseDates: !this.state.displayScreenCloseDates
    });
  }

  timeRangeUpdated(indexTimeRange) {
    if (this.state.indexTimeRangeUpdated < 0) {
      this.setState({
        indexTimeRangeUpdated: indexTimeRange,
        isUpdateInProcess: true
      });
    }
  }

  updateDaysOfWeek(selectedDay, newDay) {
    let copyDays = Object.assign({}, this.state.selectedDays);
    copyDays[selectedDay] = newDay[selectedDay];
    return copyDays;
  }

  createArraySlot(slot) {
    let arr = [];
    for (let i = 0; i < slot; i++) {
      const obj = {
        [`slot${i + 1}`]: []
      };
      arr.push(obj);
    }
    return arr;
  }

  async addClosingDates(data, action) {
    const isDateRangeOk = this.checkDateRange(data);
    const { displayScreenCloseDates } = this.state;
    if (isDateRangeOk) {
      const dateClosed = {
        update:
          action === "update"
            ? "updateDateClosed"
            : action === "add"
            ? "addDateClosed"
            : "removeDateClosed",
        dateClosed: data
      };
      const dataSent = this.submitData(dateClosed);
      if (dataSent) {
        this.setState({
          dataSentSuccess: true
        });
        this.props.enqueueSnackbar(<Localized id="tr-admin-change" />, {
          variant: "success"
        });
        this.props.onUpdateClosingDate(data, displayScreenCloseDates);
      } else {
        this.displayError("noDatas");
      }
    } else {
      this.displayError("time");
    }
  }

  checkDateRange(data) {
    return moment(data.date_start).isSameOrBefore(data.date_end);
  }

  addTimeRange(e, day, indexSlot = 0) {
    let copyDay = Object.assign({}, this.state.selectedDays);
    const { displaySlotTimes } = this.state;
    const lastTimeRange = copyDay[day].length
      ? copyDay[day][copyDay[day].length - 1].time2
      : "08:00";
    if (lastTimeRange === "00:00") return;
    const newTimeRange = { time1: lastTimeRange, time2: lastTimeRange };
    copyDay[day] = [...copyDay[day], newTimeRange];
    const newDays = this.updateDaysOfWeek(day, copyDay);
    const formateOpeningHours = this.formateOpeningHours(
      newDays,
      displaySlotTimes
    );
    this.setState({
      addTimeRangeInProgress: true,
      slotUpdated: indexSlot,
      addingNewHours: true,
      formateOpeningHours,
      dayUpdated: day
    });
  }

  displayError(type) {
    switch (type) {
      case "time":
        this.props.enqueueSnackbar(<Localized id="tr-admin-change-error" />, {
          variant: "error"
        });
        break;
      case "noData":
        this.props.enqueueSnackbar(
          <Localized id="tr-admin-error-save-data" />,
          { variant: "error" }
        );
        break;
      case "timeRangeError":
        this.props.enqueueSnackbar(<Localized id="tr-error-time-range" />, {
          variant: "error"
        });
        break;
      default:
        return;
    }
    this.setState({ isUpdateInProcess: false });
  }

  goBottomPage() {
    window.scrollTo(0, document.body.scrollHeight);
  }

  scrollToLeft() {
    const elm = document.getElementById("container-slots");
    elm.scrollLeft = elm.offsetWidth;
  }

  goToSettings(e) {
    e.preventDefault();
    this.setState({ rdcToSettings: true });
  }

  addSlotTime(e) {
    e.preventDefault();
    const {
      formateOpeningHours,
      displaySlotTimes,
      maxSlotTimesDays,
      emptySlot
    } = this.state;
    const diff = displaySlotTimes - maxSlotTimesDays;
    if (!diff) {
      const newQtiesSlot = displaySlotTimes + 1;
      const newSlot = { [`slot${newQtiesSlot}`]: emptySlot };
      const newFormateOpeningHours = [...formateOpeningHours, newSlot];
      this.setState(
        {
          displaySlotTimes: newQtiesSlot,
          formateOpeningHours: newFormateOpeningHours
        },
        () => this.scrollToLeft()
      );
    }
    return;
  }

  findMaxSlot(hoursDays) {
    const nameDays = Object.keys(hoursDays);
    return nameDays.reduce((acc, day) => {
      const slotLength = hoursDays[day].length;
      if (slotLength > acc) {
        acc = slotLength;
      }
      return acc;
    }, 0);
  }

  async submitData(data) {
    const { restaurantId } = this.state;
    const res = await CallApi(
      "put",
      "restaurant/admin/info",
      restaurantId,
      data,
      this.props.token
    );
    return !!res[0];
  }

  updateDay(day, action, newHours, indexTimeRange) {
    const { addingNewHours } = this.state;
    let newDay = [];

    if (day.length) {
      switch (action) {
        case "update":
          return addingNewHours
            ? (newDay = [...day, newHours])
            : ((day[indexTimeRange] = newHours), (newDay = day));
        case "remove":
          day.splice(indexTimeRange, 1);
          newDay = day;
          break;
        default:
          return;
      }
    } else {
      newDay.push(newHours);
    }
    return newDay;
  }

  render() {
    const {
      displayScreenCloseDates,
      addTimeRangeInProgress,
      formateOpeningHours,
      isUpdateInProcess,
      selectedDays,
      slotUpdated,
      closingDate,
      dayUpdated
    } = this.state;
    const days = Object.keys(selectedDays);
    return (
      <React.Fragment>
        {displayScreenCloseDates ? (
          <div id="container-closing-date">
            <ClosingDate
              updateDisplayCloseDates={this.displayCloseDates}
              submitDateClosed={this.addClosingDates}
              closingDate={closingDate}
            />
          </div>
        ) : (
          <div id="hours">
            <div className="container-schedule-N-add-time">
              <div className="container-schedule-days">
                <div className="container-display-day">
                  <p></p>
                  {days.map((day, index) => (
                    <p key={`${index}${day}`}>
                      {" "}
                      <Localized id={`tr-admin-${day}`} />
                    </p>
                  ))}
                </div>
                <div id="container-slots">
                  <Slots
                    addTimeRangeInProgress={addTimeRangeInProgress}
                    updateTimeRangeDay={this.updateTimeRangeDay}
                    formateOpeningHours={formateOpeningHours}
                    timeRangeUpdated={this.timeRangeUpdated}
                    isUpdateInProcess={isUpdateInProcess}
                    displayError={this.displayError}
                    addTimeRange={this.addTimeRange}
                    selectedDays={selectedDays}
                    slotUpdated={slotUpdated}
                    dayUpdated={dayUpdated}
                  />
                </div>
                <div className="container-switchs">
                  <p>
                    <Localized id="tr-admin-days-open" />
                  </p>
                  {days.map((day, index) => {
                    const hoursOfDay = selectedDays[day];
                    return (
                      <SwitchHours
                        updateTimeRangeDay={this.updateTimeRangeDay}
                        addTimeRange={this.addTimeRange}
                        hoursOfDay={hoursOfDay}
                        dayUpdated={dayUpdated}
                        key={index}
                        day={day}
                      />
                    );
                  })}
                </div>
              </div>
              <div className="container-add-slot-close-range">
                <p onClick={(e) => this.displayCloseDates(e)}>
                  <Localized
                    id={
                      closingDate && closingDate.date_start
                        ? "tr-admin-edit-close"
                        : "tr-admin-add-close"
                    }
                  />
                </p>
                <p onClick={(e) => this.addSlotTime(e)}>
                  <Localized id="tr-admin-add-slot" />
                </p>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default withSnackbar(HoursV3);
